import { createApi } from "@reduxjs/toolkit/query/react";
import { api } from "../../../api/Api";

export const RecommendationsCrud = createApi({
  reducerPath: "RecommendationsData",
  baseQuery: api,
  tagTypes: ["Sciences"],
  endpoints: (build) => ({
    getRecommendations: build.query({
      query: () => "recommendations/",
      providesTags: ["Recommendations"],
    }),
    createRecommendations: build.mutation({
      query: (body) => ({
        url: `recommendations/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Recommendations"],
    }),
    updateRecommendations: build.mutation({
      query: (body) => ({
        url: `recommendations/${body.id}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Recommendations"],
    }),
    deleteRecommendations: build.mutation({
      query: (body) => ({
        url: `recommendations/${body.id}/`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["Recommendations"],
    }),
  }),
});

export const {
 useCreateRecommendationsMutation,
 useGetRecommendationsQuery,
 useDeleteRecommendationsMutation,
 useUpdateRecommendationsMutation,
} = RecommendationsCrud;
